<template>
    <div class="animated fadeIn">
        <div class="kgr-row">
            <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--top kgr-row">
                <div class="kgr-postfix__fluid">
                    <kgr-view-picker
                        :value="view"
                        @post-input="updateView"
                    />
                </div>
                <div
                    v-if="canCreate"
                    class="kgr-postfix__fixed"
                >
                    <a
                        class="kgr-button kgr-button--accent"
                        :href="createUrl"
                    >
                        <kgr-icon
                            icon-class="add"
                            small
                            circle
                            highlight
                            class="kgr-button__icon kgr-button__icon--left"
                        />
                        <span>{{ $t('Hund anlegen') }}</span>
                    </a>
                </div>
            </div>
            <div class="kgr-grid kgr-grid--columnGutters kgr-grid--inlineBlock">
                <div
                    class="kgr-grid__cell"
                >
                    <label class="kgr-inputGroup">
                        <div class="kgr-inputGroup__label">{{ $t('Rasse') }}</div>
                        <kgr-dog-breed-select
                            v-model="breedFilter"
                            :club-id="clubId"
                            multiselect
                            @post-input="load()"
                        />
                    </label>
                </div>
                <div
                    class="kgr-grid__cell"
                >
                    <label class="kgr-inputGroup">
                        <div class="kgr-inputGroup__label">
                            {{ $t('Rasse Spezialisierung') }}
                        </div>
                        <kgr-dog-breed-specialization-select
                            v-model="breedSpecializationFilter"
                            :loading="loading"
                            :club-id="clubId"
                            multiselect
                            @post-input="load()"
                        />
                    </label>
                </div>
                <label class="kgr-inputGroup">
                    <div class="kgr-inputGroup__label">
                        {{ $t('Zugehörigkeit') }}
                    </div>
                    <kgr-checkbox
                        v-model="dogsWithoutRelation"
                        :label="$t('Hunde ohne Zugehörigkeit anzeigen')"
                        @change="load"
                    />
                </label>
            </div>
            <div class="kgr-grid kgr-grid--columnGutters kgr-row">
                <div class="kgr-grid__cell">
                    <label class="kgr-inputGroup">
                        <div class="kgr-inputGroup__label">{{ $t('search') }}</div>
                        <input
                            v-model="search"
                            type="text"
                            class="kgr-input"
                        />
                    </label>
                </div>
                <div class="kgr-grid__cell">
                    <label class="kgr-inputGroup">
                        <div class="kgr-inputGroup__label">{{ $t('sort') }}</div>
                        <kgr-generic-select
                            v-model="sort"
                            display="label"
                            no-null-option
                            :options="sortOptions"
                        />
                    </label>
                </div>
                <div class="kgr-grid__cell">
                    <div class="kgr-inputGroup__label">
&nbsp;
                    </div>
                    <kgr-button
                        v-t="'Suche starten'"
                        @click="load()"
                    />
                </div>
            </div>
        </div>
        <hr class="kgr-separator" />
        <div>
            <kgr-dog-list
                :dogs="dogs"
                :view="view"
                :loading="loading"
            />
        </div>
    </div>
</template>

<script>
import Button from '../../components/common/form/button/KgrButton.vue';
import Checkbox from '../../components/common/form/checkbox/Checkbox.vue';
import DogBreedSelect from '../../components/dog/DogBreedSelect.vue';
import DogBreedSpecializationSelect from '../../components/dog/DogBreedSpecializationSelect.vue';
import DogList from '../../components/dog/DogList.vue';
import DogRepository from '../../js/repository/DogRepository.js';
import GenericSelect from '../../components/common/form/select/GenericSelect.vue';
import Icon from '../../components/common/icon/Icon.vue';
import ViewPicker from '../../components/common/form/picker/ViewPicker.vue';

export default {
    components: {
        'kgr-dog-list': DogList,
        'kgr-view-picker': ViewPicker,
        'kgr-icon': Icon,
        'kgr-button': Button,
        'kgr-checkbox': Checkbox,
        'kgr-dog-breed-select': DogBreedSelect,
        'kgr-generic-select': GenericSelect,
        'kgr-dog-breed-specialization-select': DogBreedSpecializationSelect,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        canCreate: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data() {
        return {
            view: 'grid',
            dogs: [],
            loading: true,
            breedFilter: [],
            breedSpecializationFilter: [],
            search: '',
            sort: {label: this.$t('Name'), value: 'name'},
            sortOptions: [
                {label: this.$t('Name'), value: 'name'},
                {label: this.$t('Rasse'), value: 'breed'},
                {label: this.$t('Rasse Spezialisierung'), value: 'breedSpecialization'},
            ],
            dogsWithoutRelation: false
        };
    },
    computed: {
        createUrl() {
            return `/backend/clubs/${this.clubId}/dogs/create`;
        },
        breedKeys() {
            return this.breedFilter.map(breed => breed.key);
        },
        breedSpecializationKeys() {
            return this.breedSpecializationFilter.map(breed => breed.key);
        },
    },
    created() {
        this.load();
    },
    methods: {
        updateView(view) {
            this.view = view;
        },
        load() {
            this.dogs = [];
            DogRepository.findAll(this.clubId, this.breedKeys, this.breedSpecializationKeys, this.dogsWithoutRelation, this.search, this.sort.value)
                .then(dogs =>  {
                    this.dogs = dogs;
                })
                .catch(() => this.$notify.error('error.loadingData'));
            this.loading = false;
        }
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
